import { red } from '@mui/material/colors'
import { createTheme } from '@mui/material/styles'

// A custom theme for this app
const theme = createTheme( {
	spacing: [ 0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 48, 56, 64 ],
	typography: {
		fontFamily: [
			'Montserrat',
			'Roboto',
			'Helvetica Neue',
			'Arial',
			'sans-serif',
		].join( ',' ),
	},
	breakpoints: {
		values: {
			mobile: 0,
			tablet: 768,
			medium: 1023,
			laptop: 1025,
			landscape: 1375,
			desktop: 1440,
			large: 1920,
		},
	},
	palette: {
		primary: {
			main: '#000000',
		},
		secondary: {
			main: '#19857b',
		},
		light: {
			main: 'var(--line)'
		},
		error: {
			main: red.A400,
		},
		border: {
			primary: 'var(--line)',
		},
		text: {
			light: 'var(--line)',
			lightGrey: 'var(--text-muted)',
			black: 'var(--ink)',
			// MUI's default text.primary is a literal near-black — route it
			// through the theme variable so unstyled Typography follows the
			// dark-mode palette too.
			primary: 'var(--ink)',
			secondary: 'var(--text-muted)',
		},
		background: {
			default: 'var(--bg)',
		},
		bg: {
			white: 'var(--bg)',
		},
	},
	components: {
		MuiBox: {
			styleOverrides: {
				root: {
					height: '100%'
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					height: 48,
					padding: '0 48px',
					borderRadius: 0
				},
			},
		},
		MuiSvgIcon: {
			styleOverrides: {
				root: {
					width: 'initial',
					height: 'initial'
				},
			},
		},
		MuiBreadcrumbs: {
			styleOverrides: {
				ol: {
					alignItems: 'stretch'
				}
			}
		},
		MuiTypography: {
			styleOverrides: {
				body1: {
					fontWeight: '400',
					fontSize: 14,
					color: 'var(--text-muted)'
				},
				h1: {
					textTransform: 'uppercase',
					fontWeight: '700',
					fontSize: 88,
				},
				h2: {
					textTransform: 'uppercase',
					fontWeight: '700',
					fontSize: 32,
					marginTop: 0
				},
				h3: {
					textTransform: 'uppercase',
					fontWeight: '700',
					fontSize: 24,
					marginTop: 0
				},
				h4: {
					textTransform: 'uppercase',
					fontWeight: '700',
					fontSize: 18,
				},
				h5: {
					textTransform: 'uppercase',
					fontWeight: '400',
					fontSize: 14,
				},
				h6: {
					color: '#fa1e0e',
					fontSize: 12
				},
				subtitle1: {
					fontSize: 32,
					fontWeight: '700',
				},
				subtitle2: {
					fontSize: 14,
					fontWeight: '400',
					textTransform: 'uppercase',
					color: 'rgba(0, 0, 0, 0.2)'
				},
				smallText: {
					fontSize: 12,
					fontWeight: 'bold'
				}
			}
		},
	},
} )

export default theme
